import script from "./VChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./VChart.vue?vue&type=script&lang=ts&setup=true"

import "./VChart.vue?vue&type=style&index=0&id=7916bdd8&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7916bdd8"]])

export default __exports__